var EHDI = EHDI || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.ScoreEffect = function(stage, highscore) {    
    EHDI.aka.Container.call(this);

    var DECAY_TIME = 500;
    var FLOAT_SPEED = 0.25;


        this.scoreDisplay = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_CONT_SCOREEFFECT"));
        this.scoreDisplay.anchor.x = 0.5;
        this.scoreDisplay.anchor.y = 1;
        this.addChild(this.scoreDisplay);
    
    this.timer=0;
    this.active = false;

    this.appear = function(score)
    {
        if(this.active)
            return;

        this.scoreDisplay.y =0;
        this.scoreDisplay.text = score;
        this.scoreDisplay.anchor.x = 0.5;
        this.scoreDisplay.anchor.y = 1;
        this.timer = DECAY_TIME;
        this.active = true;
    }

    this.disappear = function()
    {
        if(!this.active)
            return;

        this.active = false;
        this.alpha =0;

    }

    this.update = function (delta)
    {
        if(!this.active)
            return false;

        this.timer -= delta;
        this.alpha = this.timer /  DECAY_TIME;
        this.scoreDisplay.y -= delta * FLOAT_SPEED;

        if (this.timer <= 0)
            {
                this.disappear();
                return true;
            }

        return false;
    }

    this.dispose = function()
    {
        if(this.scoreDisplay != null)
        {
            this.removeChild(this.scoreDisplay);
            this.scoreDisplay.destroy({children: true});
        }
        delete this.scoreDisplay;

        this.timer = null;
        this.active = null;
    }
}
EHDI.components.ScoreEffect.prototype = Object.create(EHDI.aka.Container.prototype);


EHDI.components.ScoreEffectManager = function()
{
    this.init = function(cont)
    {
        this.container = cont;
        this.scoreEffects = [];
        this.effectPool = new Pool(EHDI.components.ScoreEffect, 5);
        this.enabled = true;
    }

    this.popScore = function(x,y,score)
    {   
        if(!this.enabled)  
            return;

        var effect = this.effectPool.takeFromPool();
        effect.appear(score);
        effect.x = x;
        effect.y = y;
        this.scoreEffects.push(effect); 
        this.container.addChild(effect);
    }

    this.hideScores = function()
    {
        this.enabled = false;
        for(var i= 0, l = this.scoreEffects.length; i<l; i++)
            {
                this.scoreEffects[i].disappear();
            }
    }

    this.update = function(delta)
    {  
        if(!this.enabled)  
            return;
        if(this.scoreEffects.length > 0)
        {
            var toReturn = [];
            for(var i = 0, l = this.scoreEffects.length; i<l; i++)
                {
                    var effect =this.scoreEffects[i];
                    if(effect.update(delta))
                        toReturn.push(effect);
                }
            this.effectPool.returnBatch(this.scoreEffects, toReturn);
        }
    }

    this.dispose = function()
    {
        if(this.enable != null) this.enabled = null;
        delete this.enabled;

        if(this.effectPool != null)
        {
            delete this.effectPool;
        }
        
        if(this.scoreEffects != null)
        {
            for(let i = 0; i< this.scoreEffects.length; i++)
            {
                let scoreEffect = this.scoreEffects.pop()
                this.container.removeChild(scoreEffect);
                scoreEffect.destroy({children: true});
                scoreEffect = null;
            }
        }
        delete this.scoreEffects;
        
    }
}

